
<template>
  <section class="sm-upper">
    <div class="sm-wrap">
      <div class="sm-upper__user">
        <div
          class="sm-upper__user-avatar"
          @click="$refs.input_file.click()"
        >
          <img-loader
            v-if="avatar"
            :src="avatar"
          />
          <include-svg
            v-else
            :name="'icon-no-avatar'"
          />

          <include-svg :name="'icon-edit'" />
          <input
            ref="input_file"
            hidden
            type="file"
            name="image"
            @change="uploadFile"
          />
        </div>
        <div class="sm-upper__user-flex">
          <div class="sm-upper__user-flex-row">
            <h4>
              {{customerAccount.first_name}}&nbsp;{{customerAccount.last_name}} 
            </h4>
            <div
              v-if="customerAccount.role == 'subscriber' && userStatusObj.status"
              class="sm-upper__user-status sm-txt-capitalize"
              :class="isActive ? 'active' : ''"
            >
            
              <div class="sm-upper__user-status__text">
                <span :class="userStatusObj.classes">{{userStatusObj.status}}</span>
              </div>

          <hint-wrap
            v-if="userAccount.role == 'admin' || userAccount.role == 'super_admin' || userAccount.role == 'manager'"
            text="Specify the period for mail forwarding after <br /> a customer's PMB subscription ends"
            :left="!isMobile"
            
            >
            <template slot="content">
              <a
              href="#"
              class="sm-link"
              @click.prevent="$router.push('/admin/settings?tab=general')"
              >
                <include-svg :name="'icon-edit'" />
              </a>
            </template>
          </hint-wrap>
        
            </div>
          </div>
          <span
            v-if="customerPlan.plan_type == 'business' && customerAccount.company_name"
            class="sm-txt-upper"
          >{{customerAccount.company_name}}</span>
          <p class="sm-text-base sm-flex sm-gap-2">
            <span>Mailbox</span>
            <span class="sm-text-primary sm-font-semibold">#{{ customerAccount.pmb }}</span>
          </p>
          <span
          v-if="!customerAccount.auto_renew && customerAccount.activated_on && customerAccount.subscription_expires_on"
          >
            <b class="sm-txt-strong">Subscription will end at: </b>
            {{customerAccount.subscription_expires_on | moment('D MMM, YYYY')}}
            <a
              title="undo"
              @click="undoScheduledCancelation({id:customerAccount.id})"
              >
              <include-svg :name="'x-circle-fill'" />
            </a>
          </span>
        </div>
        <a
          href="#"
          class="sm-upper__logout"
          @click.prevent="logOut()"
        >
          <include-svg :name="'icon-logout'" />
          <span>Log out</span>
        </a>
      </div>
    </div>
    <sm-spinner :show="showSpinner" />
  </section>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import imageStore from '@/utils/image-store';
import {IsRightFileType} from '@/utils/general-data';
import ImgLoader from '@/components/ImgLoader';
import Spinner from '@/components/Spinner';
import HintWrap from '@/components/HintWrap';

export default {
  name: 'customer-top',
  components: {
    'img-loader': ImgLoader,
    'sm-spinner': Spinner,
    'hint-wrap': HintWrap,
  },
  data() {
    return {
      image: '',
      showSpinner: false,
      customerPlan: {},
      userStatusObj: {
        classes: "",
        status: ""
      }
    }
  },
  created(){
    if (this.customerAccount.plan_id)
      this.getPlan(this.customerAccount.plan_id)
        .then(res => {
          this.customerPlan = res;
    });

    this.setUserStatusObj()
  },
  computed: {
    ...mapGetters({
      customerAccount: 'customers/currentCustomer',
      isMobile: 'isMobile',
      userAccount: 'account/userAccount'
      //provider: 'provider'
    }),
    avatar() {
      let path;

      if (this.image) {
        path = this.image;
      } else if (this.customerAccount.image_url) {
        path = imageStore(this.customerAccount.image_url);
      } else {
        path = null;
      }

      return path;
    },
    isActive() {
      if(this.customerAccount.type == "AdditionalRecipient"){
        return this.customerAccount.additional_recipient_status != "inactive"
      }
      return /*this.form1583Signed && */this.customerAccount.activated_on;
    }
  },
  methods: {
    ...mapActions({
      updateCustomer: 'customers/updateCustomer',
      cancelScheduledCancelation: "customers/cancelScheduledCancelation",
      getCustomer: "customers/getCustomer",
      getPlan: 'plans/getPlan',
      findPMBs: 'mail/findPMBs'
    }),
    isRightFileType: IsRightFileType,
    logOut() {
      this.$router.push('/login');
    },
    uploadFile(e) {
      if (e.target.files.length === 0)
        return false;

      const target = e.target;
      const file = target.files[0];

      if (!this.isRightFileType(file, ['image']))
        return false;

      // update account
      let formData = new FormData();
      formData.append('customer[image]', file);

      this.updateCustomer({
        id: this.customerAccount.id,
        params: formData
      })
        .then(res => {

        })
        .catch(err => {
          const error = err.response;

          if (error && error.status === 422) {
            const messages = error.data.errors;

            Object.keys(messages).forEach(key => {
              this.errors.add({
                field: 'back_errors',
                msg: `${ToUpper(key.replace(/_/g, ' '))} ${messages[key]}`
              })
            });
          }
        });

      // create poster
      this.image = this.createPoster(file);
    },
    setUserStatusObj() {
      this.findPMBs(this.customerAccount.pmb).then(pmbs => {
        const mail_box = pmbs.find(item => (item.pmb ==  this.customerAccount.pmb) );


        if(mail_box) {
          this.userStatusObj = {
            classes: this.setItemClasses(mail_box),
            status: this.setItemStatus(mail_box)
          }
        }else {
          this.userStatusObj = {
            classes: 'inactive',
            status: 'inactive'
          }
        }


      })
    },
    createPoster(file) {
      if (!file)
        return false;

      const maxWeight = 25165824;

      let size = file.size;

      if (size > maxWeight)
        return false;

      return URL.createObjectURL(file);
    },
    undoScheduledCancelation(data){
      this.showSpinner = true;
        this.cancelScheduledCancelation(data).then(() => {
          this.$emit('update-list');
          this.getCustomer(this.customerAccount.id)
        }).then(()=>this.showSpinner = false).catch(err => {
          this.showSpinner = false;
        })
    },
    setItemClasses(item) {
      let res = '';

      switch(item.inactive) {
        case 'false':
          res = 'active';
          break;
        case 'true':
        default:
          if (/^\d+months$/.test(item.inactive)) {
                  res = 'inactive-6m';
              } 
          break;
      }

      return res;
    },
    setItemStatus(item) {
      let res;

      switch(item.inactive) {
        case 'false':
          res = 'Active';
          break;
        case 'true':
          res = 'Inactive';
        default:
          // Check if the value starts with a number followed by 'months'
          if (/^\d+months$/.test(item.inactive)) {
              // Extract the number of months
              const numMonths = parseInt(item.inactive);
              // Generate the message dynamically
              res = `Inactive within ${numMonths} month${numMonths > 1 ? 's' : ''}`;
          } else {
              // Default case if the format is not recognized
              res = 'Inactive';
          }
          // res = 'Inactive';
          break;
      }

      return res;
    },
  },
  watch: {
    customerAccount: {
    immediate: true,
    handler(val) {
      this.image = '';
    }
  }}
}
</script>

<style lang="scss">
  @use '@/assets/scss/general/mixins.scss' as *;
  @use '@/assets/scss/framework/scss-variables.scss' as *;
  @use '@/assets/scss/pages/customer/account/_upper.scss';


  .sm-hint__content {
    text-transform: none;
  }
</style>
